import React from 'react'
import Rating from '@mui/material/Rating'
import Star from '@mui/icons-material/Stars'
import EmptyStar from '@mui/icons-material/StarRate'
import { makeStyles } from '@mui/styles'
import { Box } from '@mui/material'

const MAX = 5

export const LABELS = {
  0.5: 'Avoid',
  1: 'Skip',
  1.5: 'Poor',
  2: 'Terrible',
  2.5: 'Ok',
  3: 'Alright',
  3.5: 'Good',
  4: 'Excellent',
  4.5: 'Amazing',
  5: 'Five Stars'
}

const useStyles = makeStyles({
  root: {
    width: 200,
    display: 'flex',
    alignItems: 'center'
  }
})

export const Icon = (
  <>
    <Star />
  </>
)
export const EmptyIcon = (
  <>
    <EmptyStar />
  </>
)

export const Ratings = ({
  precision = 0.5,
  value = 0,
  max = MAX,
  icon = Icon,
  readOnly = true,
  emptyIcon = EmptyIcon,
  classes = {},
  label = ''
}) => {
  return (
    <Box className={classes.root}>
      <Rating
        readOnly={readOnly}
        precision={precision}
        icon={icon}
        emptyIcon={emptyIcon}
        max={max}
        value={value}
      />
      <Box ml={2}>{label}</Box>
    </Box>
  )
}

export const RatingsWrapper = props => {
  const classes = useStyles()
  const label = props?.labels?.[props?.value] || 'label'

  return <Ratings {...props} label={label} classes={classes} />
}

export default RatingsWrapper
